import { Row } from 'components/shared/Layout';
import styled from 'styled-components';

export const InfoContainer = styled(Row)`
  &:not(.pax-extra-totals) {
    margin-bottom: 8px;
  }
`;

export const InfoLabel = styled('span')`
  font-weight: bold;
`;
